/**
 * Altura única del PrimaryHero, que es `position: fixed` en todas las vistas.
 * La consumen las tablas con `thead` sticky para no quedar por debajo del hero.
 *
 * Mantener sincronizada con `$primary-hero-height` en ./Heros.scss
 */
export const PRIMARY_HERO_HEIGHT = 144;
